<template>
  <gadget-base @hide="hideWidget" v-loading="isLoading">
    <div class="chart bar">
      <h3>店舗別日報一覧</h3>
      <el-table
        :data="screenData"
        border
        stripe
        height="calc(100% - 59px)"
        style="width: 100%">
        <el-table-column
          prop="shopName"
          header-align=center
          align=left
          width=120px
          fixed
          label="店舗名">
        </el-table-column>  
        <el-table-column
          label="日計"
          header-align=center>
          <el-table-column
            prop="salesExcludeTaxSelected"
            header-align=center
            align=right
            :formatter="addFigureFormat"
            label="売上">
          </el-table-column>
          <el-table-column
            prop="budgetSelected"
            header-align=center
            align=right
            :formatter="addFigureFormat"
            label="予算">
          </el-table-column>
          <el-table-column
            prop="budgetRatio"
            header-align=center
            align=right
            :formatter="ratioFormat"
            label="予算比">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="累計"
          header-align=center>
          <el-table-column
            prop="salesExcludeTaxMonth"
            header-align=center
            align=right
            :formatter="addFigureFormat"
            label="売上">
          </el-table-column>
          <el-table-column
            prop="budgetMonth"
            :formatter="addFigureFormat"
            header-align=center
            align=right
            label="予算">
          </el-table-column>
          <el-table-column
            prop="budgetRatioMonth"
            header-align=center
            align=right
            :formatter="ratioFormat"
            label="予算比">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </gadget-base>
</template>

<script>
import GadgetBase from './GadgetBase'
import addFigure from '@/misc/addFigure.js'
import {mapGetters} from 'vuex'

export default {
  components: {
    GadgetBase,
  },
  props: {
    targetDate: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      ratioStr: null,
      isLoading: false,
      screenData: [],
    }
  },
  computed: {
    ...mapGetters('report', ['ratioStrFunction']),
  },
  watch: {
    targetDate (targetDate) {
      if (targetDate) {
        this.fetchData()
      }
    },
  },
  created () {
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.screenData = []
      this.isLoading = true
      let targetDate = this.targetDate.format('YYYY-MM-DD')
      this.$request.reports.reportShopSalesGadget(targetDate).then(res => {
        let data = res.body
        if (data.records) {
          for (let record of data.records) {
            this.screenData.push(record.data)
          }
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    hideWidget () {
      this.$emit('hide')
    },
    ratioFormat (row, column) {
      return this.ratioStr(row[column.property])
    },
    addFigureFormat (row, column) {
      return addFigure(row[column.property])
    },
  },
}
</script>

<style scoped>
div.chart {
  padding: 5px;
  height: 100%;
}

.chart h3 {
  font-size: 14px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ShopSalesDay.vue